/**
 * KATALOG SERWISÓW SPOŁECZNOŚCIOWYCH pokazywanych w stopce menu głównego.
 *
 * ⚠️ Ta lista MUSI odpowiadać `SocialPlatformy.Kody` w `src/DogSoft.Domain/Models/BrandingSocialLink.cs`.
 * Backend pilnuje wyłącznie tego, żeby do bazy (a stamtąd do publicznego API i atrybutów HTML) nie
 * trafił dowolny tekst — ikonę i nazwę dobiera dopiero front. Dodanie kodu tylko po jednej stronie
 * kończy się albo odrzuceniem zapisu (400), albo pustą kratką zamiast ikony.
 *
 * `hint` to podpowiedź w edytorze — pokazuje, jak zwykle wygląda adres tego serwisu. To NIE jest
 * wzorzec walidacji: sprawdzamy tylko, czy adres jest http/https, bo domeny i ścieżki bywają lokalne
 * (np. pracuj.pl/firma/…), a odrzucanie poprawnych linków byłoby gorsze niż ich przyjęcie.
 */
import {
    SiFacebook, SiInstagram, SiLinkedin, SiX, SiTiktok, SiYoutube, SiThreads,
    SiBluesky, SiGlassdoor, SiSpotify, SiWhatsapp, SiTelegram, SiPinterest,
} from "react-icons/si";
import { FiGlobe, FiBriefcase, FiMessageSquare } from "react-icons/fi";

export const SOCIAL_PLATFORMS = [
    { code: "www", label: "Strona WWW", Icon: FiGlobe, color: "#0EA5E9", hint: "https://krosno.com" },
    { code: "facebook", label: "Facebook", Icon: SiFacebook, color: "#1877F2", hint: "https://www.facebook.com/nazwa" },
    { code: "instagram", label: "Instagram", Icon: SiInstagram, color: "#E4405F", hint: "https://www.instagram.com/nazwa" },
    { code: "linkedin", label: "LinkedIn", Icon: SiLinkedin, color: "#0A66C2", hint: "https://www.linkedin.com/company/nazwa" },
    { code: "x", label: "X (dawniej Twitter)", Icon: SiX, color: "#0F172A", hint: "https://x.com/nazwa" },
    { code: "tiktok", label: "TikTok", Icon: SiTiktok, color: "#111827", hint: "https://www.tiktok.com/@nazwa" },
    { code: "youtube", label: "YouTube", Icon: SiYoutube, color: "#FF0000", hint: "https://www.youtube.com/@nazwa" },
    { code: "pracujpl", label: "pracuj.pl", Icon: FiBriefcase, color: "#F59E0B", hint: "https://www.pracuj.pl/praca/…" },
    { code: "gowork", label: "GoWork", Icon: FiMessageSquare, color: "#10B981", hint: "https://www.gowork.pl/opinie/…" },
    { code: "glassdoor", label: "Glassdoor", Icon: SiGlassdoor, color: "#0CAA41", hint: "https://www.glassdoor.com/…" },
    { code: "threads", label: "Threads", Icon: SiThreads, color: "#0F172A", hint: "https://www.threads.net/@nazwa" },
    { code: "bluesky", label: "Bluesky", Icon: SiBluesky, color: "#0285FF", hint: "https://bsky.app/profile/nazwa" },
    { code: "spotify", label: "Spotify", Icon: SiSpotify, color: "#1DB954", hint: "https://open.spotify.com/…" },
    { code: "whatsapp", label: "Kanał WhatsApp", Icon: SiWhatsapp, color: "#25D366", hint: "https://whatsapp.com/channel/…" },
    { code: "telegram", label: "Telegram", Icon: SiTelegram, color: "#26A5E4", hint: "https://t.me/nazwa" },
    { code: "pinterest", label: "Pinterest", Icon: SiPinterest, color: "#BD081C", hint: "https://pl.pinterest.com/nazwa" },
];

const PO_KODZIE = SOCIAL_PLATFORMS.reduce((acc, p) => { acc[p.code] = p; return acc; }, {});

/** Definicja serwisu po kodzie. Nieznany kod → null (wywołujący decyduje, czy pominąć wiersz). */
export const socialPlatform = (code) => PO_KODZIE[String(code || "").toLowerCase()] || null;

/** Nazwa serwisu do podpisu/tooltipa. Nieznany kod oddaje sam kod — lepsze niż puste miejsce. */
export const socialPlatformLabel = (code) => socialPlatform(code)?.label || String(code || "");

/**
 * Czy adres nadaje się do zapisania. Ta sama reguła co na serwerze (BrandingController):
 * wyłącznie http/https — `javascript:` w linku klikanym z menu przez każdego pracownika
 * byłby skryptem wykonanym w jego sesji.
 */
export const isValidSocialUrl = (url) => {
    const v = String(url || "").trim();
    if (!v) return false;
    try {
        const parsed = new URL(v);
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
};
